import {isNaN} from 'lodash';

import {DurationUnit} from '../constants/dataEnum';

export const convertMilitaryTime = (hour, minute) => {
  const hours = hour;
  const minutes = minute;

  let timeValue;

  if (hours > 0 && hours <= 12) {
    timeValue = `${hours}`;
  } else if (hours > 12) {
    timeValue = `${hours - 12}`;
  } else if (hours === 0) {
    timeValue = '12';
  }

  timeValue = timeValue.toString().padStart(2, '0');
  timeValue += minutes < 10 ? `:0${minutes}` : `:${minutes}`; // get minutes
  timeValue += hours >= 12 ? ' PM' : ' AM'; // get AM/PM
  return timeValue;
};

export const convertTime = (value, fromUnit = DurationUnit.MINUTES, toUnit = DurationUnit.SECONDS) => {
  let time = value;

  switch (fromUnit) {
    case DurationUnit.MINUTES:
      time *= 60;
      break;
    case DurationUnit.HOURS:
      time *= 60 * 60;
      break;
    default:
      break;
  }

  switch (toUnit) {
    case DurationUnit.MINUTES:
      time /= 60;
      break;
    case DurationUnit.HOURS:
      time /= 3600;
      break;
    default:
      break;
  }

  return time;
};

/*
 * Convert one digit number to two digit number
 */
// eslint-disable-next-line class-methods-use-this
const twoDigit = (number) => {
  let twodigit = '00';
  if (number >= 10 || number <= -10) {
    twodigit = number;
  } else if (number < 0) twodigit = `-0${number * -1}`;
  else twodigit = `0${number.toString()}`;
  return twodigit;
};

/*
 *   Convert time from second to HH:MM:SS
 */
export function convertTimeHHMMSS(secondTime) {
  let second = parseInt(secondTime, 10);
  let hour = parseInt(second / 3600, 10);

  second %= 3600;

  let minute = parseInt(second / 60, 10);

  second %= 60;

  hour = isNaN(hour) ? '0' : hour.toString();
  minute = isNaN(minute) ? '0' : minute.toString();
  second = isNaN(second) ? '0' : second.toString();

  const timeString = `${hour}:${twoDigit(minute)}:${twoDigit(second)}`;

  return timeString;
}
